module.exports = __webpack_public_path__ + "img/linkedin.5c2b2d1d.svg";